import { put, takeLatest } from "redux-saga/effects";
import { utils } from "react-modern-calendar-datepicker";
import { initialAuthState } from "../../Auth/_redux/authRedux";

export const actionTypes = {
  setVariable: "[account] setVariable Action",
  loadingData: "[account] loadingData Action",

  sendMessage: "[account] sendMessage Action",
  hideMessage: "[account] hideMessage Action",

  getUserTravels: "[account] getUserTravels Action",
  transactionsLoaded: "[account] transactionsLoaded Action",
  getReports: "[account] getReports Action",
  getUserTransactionReports: "[account] getUserTransactionReports Action",
  userInfoLoaded: "[account] userInfoLoaded Action",
  getUserCredit: "[account] getUserCredit Action",

  addCredit: "[account] addCredit Action",
  getSupportItems: "[account] getSupportItems action",

  // changeBackPanel: "[account] ChangeBackPanel Action",
  // changePassengerPanel: "[account] changePassengerPanel Action",
  // loadTownships: "[account] loadTownships Action",
  // townshipsLoaded: "[account] townshipsLoaded Action",
  // searchForNewDate: "[account] searchForNewDate Action",
};

export const initialProfileState = {
  user_info: null,
  loading_data: false,
  snackOpen: false,
  snackMessage: "",
  snackType: "warning",
  is_travels_loaded: false,
  travels: {},
  hour: "",
  distance: "",
  count: "",
  is_transactions_loaded: false,
  transaction: [],
  credit: 0,
  reports: [],
  userCredit: "",
  supportItems:[]
};

export const reducer = (state = initialProfileState, action) => {
  switch (action.type) {
    case actionTypes.userInfoLoaded: {
      let user_info = action.payload;
      user_info.phone = action.payload.phone;
      user_info.gender_id = action.payload.gender;
      initialAuthState.user_info = user_info
      return initialAuthState
    }
    case actionTypes.setVariable: {
      const varName = action.varName;
      let prp = { ...state };
      prp[varName] = action.payload;
      return prp;
    }
    case actionTypes.loadingData: {
      return { ...state, loading_data: action.payload };
    }
    case actionTypes.sendMessage: {
      return {
        ...state,
        snackOpen: true,
        snackMessage: action.message,
        snackType: action.message_type,
      };
    }
    case actionTypes.hideMessage: {
      return { ...state, snackOpen: false };
    }
    case actionTypes.getUserTravels: {
      const travels = action.payload;
      return { ...state, travels, is_travels_loaded: true };
    }
    case actionTypes.getUserTransactionReports: {
      const transaction = action.payload;
      return { ...state, transaction };
    }

    case actionTypes.getReports: {
      const reports = action.payload;
      return { ...state, reports };
    }

    case actionTypes.getUserCredit: {
      const userCredit = action.payload;
      return { ...state, userCredit };
    }

    case actionTypes.addCredit: {
      return { ...state, credit: action.payload };
    }
    case actionTypes.getSupportItems: {
      return { ...state, supportItems: action.payload };
    }
    // case actionTypes.changePassengerPanel: {
    //     return {...state,passenger_panel:action.payload};
    // }
    // case actionTypes.loadTownships: {
    //     return {...state,townships:action.payload,is_form_ready:true};
    // }
    // case actionTypes.searchForNewDate: {
    //     return {...state,departure_datetime:action.date,is_form_ready:false};
    // }
    default:
      //TODO: setDeparture datetime here
      return { ...state };
  }
};

export const actions = {
  user_info_loaded: (user_info) => ({
    type: actionTypes.userInfoLoaded,
    payload: user_info,
  }),
  handle_variables: (varName, value) => ({
    type: actionTypes.setVariable,
    varName: varName,
    payload: value,
  }),
  sendMessage: (message, type) => ({
    type: actionTypes.sendMessage,
    message: message,
    message_type: type,
  }),
  hideMessage: () => ({ type: actionTypes.hideMessage }),
  getUserTravels: (data) => ({
    type: actionTypes.getUserTravels,
    payload: data,
  }),
  getReports: (reports) => ({ type: actionTypes.getReports, payload: reports }),
  getUserTransactionReports: (transaction) => ({
    type: actionTypes.getUserTransactionReports,
    payload: transaction,
  }),
  transactions_loaded: (data) => ({
    type: actionTypes.transactionsLoaded,
    payload: data,
  }),
  set_loading: (data) => ({ type: actionTypes.loadingData, payload: data }),
  addCreditCompleted: (data) => ({
    type: actionTypes.addCredit,
    payload: data,
  }),
  getUserCredit: (userCredit) => ({
    type: actionTypes.getUserCredit,
    payload: userCredit,
  }),
  getSupportItems: (supportItems) => ({
      type:actionTypes.getSupportItems,
      payload:supportItems
  })

  // change_backPanel: (state) => ({type: actionTypes.changeBackPanel, payload: state}),
  // change_passenger_panel: (state) => ({type: actionTypes.changePassengerPanel, payload: state}),
  // loadTownships: (data) => ({type: actionTypes.loadTownships,payload:data}),
};

export function* saga() {
  // yield takeLatest(actionTypes.UserRequested, function* userRequested() {
  //     const {data: user} = yield getUserByToken();
  //
  //     yield put(actions.fulfillUser(user));
  // });
}
